import {
  TPartSettingsTabKey,
} from '@/page/part/settings.ts';

const tabs: Record<TPartSettingsTabKey, string> = {
  attributes: 'Atrybuty',
  tableView: 'Tabela przeglądu',
};

export default {
  tabs,
};
